module.exports = __webpack_public_path__ + "img/middle2.3ac3c7a2.png";